
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waitlist",
      function () {
        return require("private-next-pages/waitlist.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/waitlist"])
      });
    }
  